module.exports = __webpack_public_path__ + "static/media/HIPER.0810a4c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/HIPER.svg
// module id = 88
// module chunks = 0